import {
  formatTimedMatchingGridJsonForCsv,
  isTimedMatchingGridPayload,
} from './timedMatchingGridSubmissionDisplay'

const NO_RESPONSE = 'No response'

export const formatPlainDisplayText = (value) => {
  if (value == null || value === '') return ''
  return String(value)
    .replace(/<[^>]*>?/gm, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&#160;/gi, ' ')
    .replace(/&[a-zA-Z]+;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export const formatDisplayForCsv = display => {
  if (!display || display.kind === 'empty') {
    return NO_RESPONSE
  }
  switch (display.kind) {
    case 'list':
      return (display.items || []).map(item => formatPlainDisplayText(item)).join('; ')
    case 'log':
      if (display.entries?.length) {
        return display.entries.join('; ')
      }
      return display.summary || NO_RESPONSE
    case 'audio':
      return display.name || 'Audio recording'
    case 'image':
      return display.name || 'Image response'
    case 'file':
      if (display.names?.length) {
        return display.names.join('; ')
      }
      return display.name || NO_RESPONSE
    case 'matrix':
      return (display.rows || [])
        .map(row => {
          const label = formatPlainDisplayText(row.row_label)
          const response = formatPlainDisplayText(row.response) || NO_RESPONSE
          return `${label}: ${response}`
        })
        .join('; ')
    case 'json':
      if (isTimedMatchingGridPayload(display.value)) {
        return formatTimedMatchingGridJsonForCsv(display.value)
      }
      return JSON.stringify(display.value ?? {})
    case 'scale':
    case 'text':
      return formatPlainDisplayText(display.value) || NO_RESPONSE
    default:
      return formatPlainDisplayText(display.value || display.summary) || NO_RESPONSE
  }
}

export const buildSubmissionCsv = (submission, instrumentName) => {
  const header = ['#', 'Question', 'Response']
  const rows = (submission?.questions || []).map(question => [
    question.number,
    `"${formatPlainDisplayText(question.text).replace(/"/g, '""')}"`,
    `"${formatDisplayForCsv(question.display).replace(/"/g, '""')}"`,
  ])
  const csvContent = [header, ...rows].map(row => row.join(',')).join('\n')
  const safeName = (instrumentName || 'instrument').replace(/[^\w\-]+/g, '_')
  const datePart = submission?.submitted_at
    ? submission.submitted_at.slice(0, 10).replace(/-/g, '')
    : 'export'
  return {
    content: csvContent,
    filename: `${safeName}_${datePart}.csv`,
  }
}

export const VIEWER_SUPPORTED_INSTRUMENT_TYPES = ['SURVEY', 'EDIARY', 'CLINRO']

export const canViewInstrumentResponses = ({ completed, instrumentType, isV2Architecture }) =>
  !!completed &&
  isV2Architecture &&
  VIEWER_SUPPORTED_INSTRUMENT_TYPES.includes(instrumentType)

export { NO_RESPONSE }
